module.exports = {
      id: "user-icon-usage",
      viewBox: "0 0 21 21",
      url: __webpack_public_path__ + "svg-sprite-f7c87499d4b6955c7faa356accbb279e.svg#user-icon",
      toString: function () {
        return this.url;
      }
    }